import React from 'react';
import { Helmet } from 'react-helmet-async';

interface Props {
    title: string;
    description?: string;
    canonical?: string;
    ogImage?: string;
    ogType?: string;
    schema?: Record<string, any>;
    children?: React.ReactNode;
}

const PageTitle: React.FC<Props> = ({ 
    title, 
    description = "PocketProf: The ultimate educator's toolkit for assessment, report cards, and classroom management. Reclaim your weekends with time-saving tools designed for teachers.",
    canonical,
    ogImage = "/favicon.svg",
    ogType = "website",
    schema,
    children 
}) => {
    const fullTitle = `${title} | PocketProf`;
    const url = canonical || window.location.origin + window.location.pathname;

    return (
        <>
            <Helmet>
                <title>{fullTitle}</title>
                <meta name="description" content={description} />
                <link rel="canonical" href={url} />
                
                <meta property="og:type" content={ogType} />
                <meta property="og:title" content={fullTitle} />
                <meta property="og:description" content={description} />
                <meta property="og:image" content={ogImage} />
                <meta property="og:url" content={url} />

                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content={fullTitle} />
                <meta name="twitter:description" content={description} />
                <meta name="twitter:image" content={ogImage} />

                {schema && (
                    <script type="application/ld+json">
                        {JSON.stringify(schema)}
                    </script>
                )}
            </Helmet>
            {children}
        </>
    );
};

export default PageTitle;
